import { create } from 'zustand';

const useStore = create((set) => ({
  mp: {},
  setMP: (mp) => set({ mp }),
  resetMP: () => set({ mp: {} }),
}));

export { useStore };
